module.exports = __webpack_public_path__ + "assets/img/Goal.svg?16f0a0b873de7869ada94cb24e802ce1";